import google from "assets/img/nav-icons/google.png";
import githubLight from "assets/img/nav-icons/github-light.png";
import osiris from "assets/img/logos/osiris.png";
import horus from "assets/img/logos/horus.png";

export const quickLinks = [
  {
    img: osiris,
    title: "Osiris",
    link: "/osiris",
    moduleName: "Osiris",
  },
  {
    img: horus,
    title: "Horus",
    link: "/horus",
    moduleName: "Horus",
  },
  { hr: true },
  {
    avatarText: "S",
    title: "Showcase",
    link: `/solutions-showcase`,
    contentClass: "bg-primary-subtle text-primary",
  },
  // { hr: true },
  // { img: google, title: "Google" },
  // { img: githubLight, title: "Github" },
];
